var map = {
	"./ai-task-answering.svg": "10c1",
	"./ai-task-classification.svg": "ae21",
	"./ai-task-extraction.svg": "20c3",
	"./ai-task-generation.svg": "7320",
	"./ai-task-hire.svg": "1903",
	"./ai-task-sentiment.svg": "d637",
	"./ai-task-summarization.svg": "9bc5",
	"./ai-task-tabular-classification.svg": "21d5",
	"./ai-task-tagging.svg": "80fa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba2a";